import { InvoiceReportOrderByDirection } from 'ap-openapi';
import {
  mapColumnKeyToApiSortField,
  OrderByItem,
  SortField,
} from '@/features/admin_invoice_reports/types';

export const buildOrderByArray = (
  sortOrders: { order: 'ascend' | 'descend'; columnKey: string }[] | undefined
): OrderByItem[] | undefined => {
  if (!sortOrders || sortOrders.length === 0) return undefined;
  return sortOrders.map((sortState) => {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const field = mapColumnKeyToApiSortField(sortState.columnKey as SortField);
    const direction: InvoiceReportOrderByDirection =
      sortState.order === 'ascend' ? 'asc' : 'desc';
    return { field, direction };
  });
};
